import GlobalStoreHelper from '../../modules/StorePickup/GlobalStoreHelper';

export default class StockAlert {
  constructor() {
    this.C = {
      product_tags: window.product_tags
    };

    // Render module
    this.init();
  }

  checkStockAlert = (product_tags) => {
    const storeCode = GlobalStoreHelper.getStoreCode();
    if (storeCode !== null && product_tags?.includes(`low_stock_label_${storeCode}`)) {
      document.querySelector('.stock-alert')?.classList.remove('hidden');
    } else {
      document.querySelector('.stock-alert')?.classList.add('hidden');
    }
  };

  /**
   * Render the work flow to can attach each module
   **/
  async init() {
    const { product_tags } = this.C;

    this.checkStockAlert(product_tags);
  }
}

window.addEventListener("load", function () {
  new StockAlert();

  const storeObserver = new MutationObserver(() => {
    new StockAlert();
  });
  
  storeObserver.observe(document.querySelector(".subtitle.store-name"), { subtree: false, childList: true });
});
